import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertWebpToJpeg() {
  return (
    <ImageConverterTemplate
      sourceFormat="WebP"
      targetFormat="JPEG"
      acceptTypes=".webp,image/webp"
      slug="convert-webp-to-jpeg"
      gradientColors="from-green-500 to-amber-500"
      accentColor="orange"
      showQualitySlider={true}
    />
  );
}
